

(function($, App, Utils, Components){
  'use strict';

  var logger = new Logger("DataSelectEnable");

  Components.create('DataSelectEnable', {

    bindEvents: function() {

      $('.data-select').off('change').on('change', function(e) {
        var
          self = $(this)
          context = self.closest(self.data('context')),
          option = self.find(':selected'),
          target = option.data('selectEnable'),
          allTargets = [];

        self.find('option[data-select-enable]').each(function(i, e) {
          allTargets.push( $(e).data('selectEnable') );
        });

        // Hide all
        logger.d("Hiding targets:", allTargets);
        context.find( allTargets.join(',') ).addClass('hidden');

        if (target) {
          // Show target
          logger.d("Showing target:", target);
          context.find( target ).removeClass('hidden');
        }

      });
    },

    init: function() {
      this.bindEvents();
    }
  });

})(jQuery, window.App, window.App.Utils, window.App.Components);
